import { Box } from '@mui/material'
import { useAppSelector } from 'store/hooks'
import { CardStandart } from 'ui/CardStandart'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import FatnessHealthTable from '../shared/FatnessHealthTable'
import HoofHealthTable from '../shared/HoofHealthTable'

interface HealthCardProps {
	cowId: number
	lactationLength?: number
}

const HealthCard = (props: HealthCardProps) => {
	const { cowId, lactationLength } = props
	const { permissions } = useAppSelector(state => state.authReducer)

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
			{permissions?.license_limpness && (
				<CardStandart sx={{ p: '24px' }}>
					<TypographyHeader>Здоровье конечностей</TypographyHeader>
					<HoofHealthTable cowId={cowId} />
				</CardStandart>
			)}
			{permissions?.license_fatness && (
				<CardStandart sx={{ p: '24px' }}>
					<TypographyHeader>Динамика упитанности</TypographyHeader>
					<FatnessHealthTable cowId={cowId} lactationLength={lactationLength} />
				</CardStandart>
			)}
		</Box>
	)
}

export default HealthCard
